import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import List from './components/List'
import Detail from './components/Detail'

const InvoiceModule: RouteObject = {
    path: 'invoices',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default InvoiceModule
